import { CollisionEvent, Vector2D } from '@/types';

export class CollisionEventPool {
  private pool: CollisionEvent[] = [];

  constructor(initialSize: number = 2000) {
    for (let i = 0; i < initialSize; i++) {
      this.pool.push(this.createEmptyEvent());
    }
  }

  private createEmptyEvent(): CollisionEvent {
    return {
      id: '',
      pos: { x: 0, y: 0 },
      startTime: 0,
      radius: 0,
      color: '',
      effectType: '',
      duration: 0
    };
  }

  get(
    id: string,
    pos: Vector2D,
    startTime: number,
    radius: number,
    color: string,
    effectType: string,
    duration: number
  ): CollisionEvent {
    let event = this.pool.pop();
    if (!event) {
      event = this.createEmptyEvent();
    }

    event.id = id;
    event.pos.x = pos.x;
    event.pos.y = pos.y;
    event.startTime = startTime;
    event.radius = radius;
    event.color = color;
    event.effectType = effectType;
    event.duration = duration;

    return event;
  }

  release(event: CollisionEvent) {
    this.pool.push(event);
  }

  getAvailableCount(): number {
    return this.pool.length;
  }
}
